<template>
  <div class="search-form">
    <el-select v-model="level" filterable placeholder="等级" :clearable="true">
      <el-option
        v-for="item in $store.state.levels"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-input v-model="search" placeholder="输入关键字搜索" style="width:200px;"/>
  </div>
</template>

<script>
export default {
  name: 'TypeSearch',
  data () {
    return {
      level: null,
      search: null
    }
  },
  watch: {
    level () {
      this.$emit('change', 'level')
    },
    search () {
      this.$emit('change', 'search')
    }
  }
}
</script>

